export default __webpack_public_path__ + "static/media/21.abb3187d.jpeg";